<template>
  <div class="container" style="height: 100%">
    <v-row>
      <v-col cols="12" md="8">
        <h4 class="mb-2">Detail Peserta</h4>
        <v-skeleton-loader type="card" :loading="loading">
          <v-card outlined>
            <div class="pa-5">
              <v-alert
                text
                border="left"
                color="primary"
                v-if="
                  participant.phone_number === null ||
                  participant.nim === null ||
                  participant.faculty === null
                "
              >
                <v-row align="center">
                  <v-col class="grow" cols="12" md="8">
                    Lengkapi profil kamu untuk informasi kepesertaan dan cetak
                    sertifikat
                  </v-col>
                  <v-col class="shrink" cols="12" md="4">
                    <v-btn
                      elevation="0"
                      :to="{ name: 'MyAccountEdit' }"
                      class="float-md-right"
                      >Ubah Profil</v-btn
                    >
                  </v-col>
                </v-row>
              </v-alert>
              <div class="my-3">
                <div class="subtitle-2">Nama Lengkap</div>
                <div>{{ participant.name }}</div>
              </div>
              <v-divider />
              <div class="my-3">
                <div class="subtitle-2">Nomor Induk Mahasiswa</div>
                <div>
                  {{ participant.nim ? participant.nim : '-' }}
                </div>
              </div>
              <v-divider />
              <div class="my-3">
                <div class="subtitle-2">Nomor Telepon</div>
                <div>
                  {{
                    participant.phone_number ? participant.phone_number : '-'
                  }}
                </div>
              </div>
              <v-divider />
              <div class="my-3">
                <div class="subtitle-2">Alamat Email</div>
                <div>
                  {{ participant.email ? participant.email : '-' }}
                </div>
              </div>
              <v-divider />
              <div class="my-3">
                <div class="subtitle-2">Perguruan Tinggi</div>
                <div>
                  {{ participant.university ? participant.university : '-' }}
                </div>
              </div>
              <v-divider />
              <div class="my-3">
                <div class="subtitle-2">Fakultas</div>
                <div>
                  {{ participant.faculty ? participant.faculty : '-' }}
                </div>
              </div>
            </div>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="4">
        <h4 class="mb-2">Informasi Event</h4>
        <v-skeleton-loader type="card" :loading="loading">
          <v-card outlined>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="title">{{
                  data.event_title
                }}</v-card-title>
                <v-card-subtitle>
                  <div>{{ data.event_date }}, {{ data.event_time }}</div>
                  <div>{{ data.event_place }}</div>
                </v-card-subtitle>
              </div>

              <v-avatar class="ma-3" size="80" tile>
                <v-img :src="data.cover"></v-img>
              </v-avatar>
            </div>

            <v-card-text>
              <v-row>
                <v-col cols="6">Ticket {{ data.ticket_name }} (Qty 1)</v-col>
                <v-col cols="6" class="font-weight-bold text-right">{{
                  data.price_string
                }}</v-col>
                <v-col cols="6">Diskon</v-col>
                <v-col cols="6" class="font-weight-bold text-right">-</v-col>
                <v-col cols="6">Biaya Layanan</v-col>
                <v-col cols="6" class="font-weight-bold text-right">{{
                  data.master_services_fee
                }}</v-col>
                <v-col cols="6" v-if="data.unique_price != 0">Kode Unik</v-col>
                <v-col
                  cols="6"
                  v-if="data.unique_price != 0"
                  class="font-weight-bold text-right"
                  >{{ data.unique_price }}</v-col
                >
                <v-col cols="12"><v-divider /></v-col>
                <v-col cols="6" class="font-weight-bold">Total</v-col>
                <v-col cols="6" class="font-weight-bold text-right">{{
                  data.total
                }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-btn
            class="mt-4"
            color="primary"
            id="pay-button"
            @click="gotoCheckoutPayment"
            block
            large
            bottom
            >{{ textBtnBeli }}</v-btn
          >
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'Checkout',
  data() {
    return {
      loading: true,
      data: [],
      error: false,
      errorMessage: null,
      ticket_id: this.$route.params.ticket_id,
      token: 'Bearer ' + localStorage.getItem('token'),
      user: JSON.parse(localStorage.getItem('user')),
      textBtnBeli: 'Lanjutkan',
      resultCheckout: null,
      participant: [],
    };
  },

  created() {
    this.fetchParticipantDetail();
    this.fetchOrderDetail();
  },

  methods: {
    gotoCheckoutPayment() {
      if (this.data.price == 0) {
        this.checkoutSubmit();
      } else {
        this.$router.push({
          name: 'CheckoutPayment',
          params: { ticket_id: this.ticket_id },
        });
      }
    },
    checkoutSubmit() {
      this.textBtnBeli = 'Memproses...';

      Axios.post(
        process.env.VUE_APP_API + 'checkout',
        {
          event_ticket_id: this.data.id,
          event_id: this.data.event_id,
          user_id: this.user.id,
          unique_price: this.data.unique_price,
        },
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          this.resultCheckout = response.data;
          console.log(this.resultCheckout);
          if (this.resultCheckout.status == 'success') {
            this.$router.push({
              name: 'CheckoutSuccess',
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },

    fetchOrderDetail() {
      Axios.get(process.env.VUE_APP_API + 'checkout/' + this.ticket_id, {
        headers: {
          Authorization: this.token,
        },
      })
        .then((response) => {
          this.data = response.data.data;
          localStorage.setItem('unique_price', this.data.unique_price);
          // console.log(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },

    fetchParticipantDetail() {
      Axios.get(process.env.VUE_APP_API + 'user/', {
        headers: {
          Authorization: this.token,
        },
      })
        .then((response) => {
          this.participant = response.data.data;
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>

<!--<input type="text" id="snap-token" value="af8e5af3-003b-412e-a814-82633b1602b9" class="form-input">-->
<!--<button id="pay-button" class="btn btn-primary input-group-btn">Proceed to Payment</button>-->
